import { cn } from '@virginexperiencedays/tailwind';
import { Price } from '@virginexperiencedays/products/src/types';

import { BodyText } from '../../../../typography/BodyText';
import { DisplayHeading } from '../../../../typography/DisplayHeading';
import { LinkWrap } from '../../../../navigation/LinkWrap';
import { IconFindMore } from '../../../../icons/IconFindMore';
import { decodeHTMLEntities } from '../../../../utils/decodeHTMLEntities';

type ContentBodyProps = {
  price: Price;
  isSingle: boolean;
  url: string;
  contentKey: string;
  firstParagraph: string;
  title: string;
  title_override?: string;
};

export const ContentBody = ({
  price,
  isSingle,
  url,
  contentKey,
  firstParagraph,
  title,
  title_override,
}: ContentBodyProps) => {
  const { rrp, displayPrice, percentOff, fixedAmountOff } = price ?? {};

  return (
    <LinkWrap
      className="text-neutral-strong"
      href={url}
      key={contentKey}
      target="_blank"
      rel="noreferrer"
    >
      <DisplayHeading className="mb-2" size="4" as="h3">
        {title_override || title}
      </DisplayHeading>
      <BodyText className={cn(!isSingle ? 'hidden' : 'line-clamp-3', 'md:line-clamp-3')}>
        {!!firstParagraph?.length && decodeHTMLEntities(firstParagraph)}
      </BodyText>
      <div
        className={cn(
          'flex flex-col flex-nowrap md:min-w-full md:justify-between md:pt-6',
          isSingle ? 'pt-6 md:flex-row md:items-center' : 'md:items-start'
        )}
      >
        {displayPrice && rrp && (fixedAmountOff || percentOff) ? (
          <div className="flex items-baseline leading-none">
            <span className="mr-1 text-base font-semibold leading-none">
              £{displayPrice.toFixed(2)}
            </span>
            <span className="mr-2 text-sm leading-none line-through">£{rrp.toFixed(2)}</span>
            <div className="bg-background-primary-faded rounded-sm px-1 py-0.5 text-xs font-semibold">
              {fixedAmountOff > 0 ? `£${fixedAmountOff} OFF` : `${percentOff}% OFF`}
            </div>
          </div>
        ) : (
          displayPrice &&
          rrp && (
            <span className="mr-1 text-base font-semibold leading-none">
              £{displayPrice.toFixed(2)}
            </span>
          )
        )}

        <div
          className={cn(
            isSingle ? 'flex md:mt-0' : 'hidden',
            'text-link mt-4 items-center md:flex'
          )}
        >
          <BodyText className="text-sm font-semibold leading-snug">Find out more</BodyText>
          <IconFindMore width="6px" height="8px" style={{ marginLeft: '10.4px' }} />
        </div>
      </div>
    </LinkWrap>
  );
};
